import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { ImageComp } from "../../Components/ImageCompo/ImageComp";
import CircleIcon from "@mui/icons-material/Circle";
import HeaderCompo from "../../Components/HeaderComp/HeaderCompo";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Initial from "./InitialRegistration/Initial";
import Pan from "./Discover/Pan";
import LegalRegistration from "./Discover/LegalRegistration";
import HeadOfOrganization from "./Discover/HeadOfOrganization";
import ContactPersonOfOrganization from "./Discover/ContactPersonOfOrganization";
import BriefDescriptionAboutNPO from "./Discover/BriefDescriptionAboutNPO";
import SeeWhatWeDo from "./Discover/SeeWhatWeDo";
import LogoutIcon from "@mui/icons-material/Logout";
import ExemptionAndDeduction from "./Engage/ExemptionAndDeduction";
import FcraDetials from "./Engage/FcraDetials";
import { McaDetails } from "./Engage/McaDetails";
import DonationInformation from "./Contribution/DonationInformation";
import UndertakingInformation from "./Contribution/UndertakingInformation";
import BasicInformation from "./BronzeDetails/BasicInformation";
import MaterialChanges from "./BronzeDetails/MaterialChanges";
import DocumentPart1 from "./BronzeDetails/DocumentPart1";
import OrganizationDetails from "./ExpressionOfInterest/OrganizationDetails";
import HeadAndFinanceTeam from "./ExpressionOfInterest/HeadAndFinanceTeam";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import CertificationInterestFinancialReadiness from "./ExpressionOfInterest/CertificationInterestFinancialReadiness";
import AdditionalInformation from "./ExpressionOfInterest/AdditionalInformation";
import History from "./Level1/History";
import TargetSegment from "./Level1/TargetSegment";
import Vision from "./Level2/Vision";
import Mission from "./Level2/Mission";
import StrategyAndGoal from "./Level2/StrategyAndGoal";
import Section7 from "./Discover/Section7";
import Section8 from "./Discover/Section8";
import Section9 from "./Discover/Section9";
import AnnualFinancialDetails from "./Engage/AnnualFinancialDetails";
import SustainableDevelopment from "./Engage/SustainableDevelopment";
import OtherOrganisationDetails from "./Engage/OtherOrganisationDetails";
import Undertaking2 from "./undertaking/Undertaking2";
import TopProgramme from "./ActivitiesAndProgramme/TopProgramme";
import { useEffect } from "react";
import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RiskAndReputation from "./RiskAndResilience/RiskAndReputation";
import PreventionOfRisk from "./RiskAndResilience/PreventionOfRisk";
import OrganisationalResilence from "./RiskAndResilience/OrganisationalResilence";
import ExternalReferences from "./RiskAndResilience/ExternalReferences";
import StaffDistribution from "./Operation/StaffDistribution";
import PeopleEngaged from "./Operation/PeopleEngaged";
import OperationsPlanning from "./Operation/OperationsPlanning";
import Collaborations from "./Operation/Collaborations";
import SourcesOfFunding from "./ActivitiesAndProgramme/SourcesOfFunding";
import ProgrammeDetails from "./ActivitiesAndProgramme/ProgrammeDetails";
import TopDonors from "./ActivitiesAndProgramme/TopDonors";

import BalanceSheet from "./Finance/BalanceSheet";
import RecieptsAndPayments from "./Finance/RecieptsAndPayments";
import IncomeAndExpenditure from "./Finance/IncomeAndExpenditure";
import AuditAndAuditorDetails from "./Finance/AuditAndAuditorDetails";
import BankAccountDetails from "./Finance/BankAccountDetails";
import AccountingPractices from "./Finance/AccountingPractices";
import FinancialReporting from "./Finance/FinancialReporting";
import ReceiptsAndIncome from "./Finance/ReceiptsAndIncome";
import PaymentsAndExpenditure from "./Finance/PaymentsAndExpenditure";
import Assets from "./Finance/Assets";
import Liabilities from "./Finance/Liabilities";
import DataPrivacyAndSecurity from "./DataPrivacy/DataPrivacyAndSecurity";
import Capabilities from "./Capabilities/Capabilities";
import Challenges from "./Challenges/Challenges";
import Accountability from "./Accountability/Accountability";
import InternalCompliance from "./Compliance/InternalCompliance";
import CompliancePrimary from "./Compliance/CompliancePrimary";
import ComplianceIncome from "./Compliance/ComplianceIncome";
import ComplianceFcra from "./Compliance/ComplianceFcra";
import ComplianceStakeholders from "./Compliance/ComplianceStakeholders";
import GoverningBodyMemberDetails from "./GoverningBodyMemberDetails/GoverningBodyMemberDetails";
import FunctioningOfTheBoard from "./FunctioningOfTheBoard/FunctioningOfTheBoard";
import GoodGovernancePractices from "./GoodGovernancePractices/GoodGovernancePractices";
import SocialImpact from "./SocialImpact/SocialImpact";
import { useQuery } from "@tanstack/react-query";
import { BronzeSectionGsnGet } from "../../Store/auth/register";
import Loading from "../../Components/Loader/Loading";
import NeedsOrAsk from "./NeedsOrAsk/NeedsOrAsk";
import Details from "./ParticipationOfResearch/Details";
import WorkshopAttended from "./WorkshopAttended/WorkshopAttended";
import DonationDocuments from "./Contribution/DonationDocuments";
import PeopleEngagedBasedOnNature from "./Operation/PeopleEngagedBasedOnNature";
import PeopleEngagedBasedOnDiversity from "./Operation/PeopleEngagedBasedOnDiversity";
import MonthlyCompensation from "./Operation/MonthlyCompensation";
import ExpressionOfInterest from "./ExpressionOfInterest/ExpressionOfInterest";
import HeaderSec from "../../Components/HeaderSec/HeaderSec";
const drawerWidth = 340;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const RegistrationMainPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const application_no = localStorage.getItem("RegKey");
  const DbName = localStorage.getItem("Db_name");
  const token = localStorage.getItem("NpoToken");

  const aFterRegistrationTab = [
    "Expression of Interest",
    "Contribution",
    "Statutory Information & Documentation",
    "Risk, Resilience & Reputation",
    "Pillar 1 - Situational Analysis",
    "Pillar 2 - Theory of Change",
    "Activities & Programme Management",
    "Operations",
    "Finance",
    "Data Privacy & Security",
    "Accountability",
    "Compliance",
    "Governance",
    "Pillar 6 - Evidence of Impact ",
    "Pillar 7 - Learning & Reflection",
    "Needs & Asks",
    "Undertaking from the Board",
    "Participation in Research",
    "Workshops Attended",
  ];

  const isTokenTabs = [
    'Organisation Summary', 'Registrations'
  ]

  const registrationTabs = [
    {
      tab: "Get Started",
      subTabs: ["Get Started"],
    },
    {
      tab: "Organisation Summary",
      subTabs: [
        "PAN and Legal Registration",
        "Addresses",
        `Head of Organisation's Details`,
        "Social Media Profile",
        "Contact Details",
        "What We Do",
        "Promoted by",
        "Undertaking",
        "Profile Related Information",
      ],
    },
    {
      tab: "Registrations",
      subTabs: [
        "Tax exemption and deduction",
        "FCRA Details",
        "Other registration details",
        "Annual financial details",
        "Sustainable Development Goals (SDGs)",
        "Other organisation details",
      ],
    },

    {
      tab: "Expression of Interest",
      subTabs: ["Expression of Interest"],
    },
    {
      tab: "Contribution",
      subTabs: [
        "Donor Details",
        // "Undertaking & Contact Information",
        "Donation Documents",
      ],
    },
    {
      tab: "Statutory Information & Documentation",
      subTabs: [
        "Additional Organisational Details",
        "Material Changes",
        "Documents as explained",
      ],
    },
    {
      tab: "Risk, Resilience & Reputation",
      subTabs: [
        "Risk And Reputation",
        "Prevention Of Risk",
        "Organisational Resilence",
        "External References",
      ],
    },
    {
      tab: "Pillar 1 - Situational Analysis",
      subTabs: ["History", "Target Segment"],
    },
    {
      tab: "Pillar 2 - Theory of Change",
      subTabs: ["Vision", "Mission", "Strategy & Goals"],
    },
    {
      tab: "Activities & Programme Management",
      subTabs: [
        "Top Programmes",
        "Top Donors",
        "Sources of Funding",
        "Programme Details",
      ],
    },
    {
      tab: "Operations",
      subTabs: [
        "Staff Distribution",
        "Monthly Compensation",
        "People Engaged",
        "People Engaged Based on Nature of Engagement",
        "People Engaged Based On Diversity",
        "Operations Planning & Management",
        "Collaborations",
      ],
    },
    {
      tab: "Finance",
      subTabs: [
        "Balance Sheet",
        "Receipts & Payments",
        "Income & Expenditure",
        "Audit & Auditor Details",
        "Bank Account Details",
        "Accounting Practices",
        "Financial Reporting to Funders",
        "Receipts & Income",
        "Payments & Expenditure",
        "Assets",
        "Liabilities",
      ],
    },
    {
      tab: "Data Privacy & Security",
      subTabs: ["Data Privacy & Security"],
    },
    {
      tab: "Accountability",
      subTabs: [
        "Accountability",
        "Functioning Of The Board",
        "Good Governance Practices",
      ],
    },
    {
      tab: "Compliance",
      subTabs: [
        "Internal Compliance",
        "Compliance with Primary Regulatory Authority",
        "Compliance with Income Tax",
        "Compliance with FCRA",
        "Compliance with Stakeholders",
      ],
    },
    {
      tab: "Governance",
      subTabs: ["Governing Body Member Details"],
    },

    {
      tab: "Pillar 6 - Evidence of Impact ",
      subTabs: ["Social Impact"],
    },
    {
      tab: "Pillar 7 - Learning & Reflection",
      subTabs: ["Capabilities", "Challenges"],
    },
    {
      tab: "Needs & Asks",
      subTabs: ["Needs & Asks"],
    },
    {
      tab: "Undertaking from the Board",
      subTabs: ["Undertaking "],
    },
    {
      tab: "Participation in Research",
      subTabs: ["Details"],
    },
    {
      tab: "Workshops Attended",
      subTabs: ["Workshop Details"],
    },
  ];
  const theme = useTheme();
  const [open, setOpen] = React.useState(true);
  const [subTabs, setSubTabs] = React.useState({
    "Get Started": true,
  });
  const [tabs, setTabs] = React.useState({
    "Get Started": true,
  });

  const [isParentTabOpen, setIsParentTabOpen] = React.useState(false);

  // Function to toggle the parent tab visibility
  const toggleParentTab = () => {
    setIsParentTabOpen((prevState) => !prevState);
  };

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const selectTab = (name) => {
    if (tabs?.[name]) {
      setTabs({ [name]: false });
    } else {
      setTabs({ [name]: true });
    }
  };

  const updateSubtab = (subTab) => {
    setSubTabs({ [subTab]: true });
  };

  const openSubTabs = (tab) => {
    if (tabs?.[tab]) {
      setTabs({ ...tabs, [tab]: false });
    } else {
      setTabs({ ...tabs, [tab]: true });
    }
  };

  useEffect(() => {
    const selectedKey = Object.keys(subTabs)[0];
    registrationTabs?.map((ele) => {
      if (ele?.subTabs?.includes(selectedKey)) {
        setTabs({ [ele.tab]: true });
      }
    });
  }, [subTabs]);

  useEffect(() => {
    if (location?.state?.tab) {
      const data = location.state.tab;
      const subTabs = registrationTabs.find(
        (ele) => ele.tab.toLowerCase() === data?.toLowerCase()
      );
      setTabs({ [data]: true });
      setSubTabs({ [subTabs?.subTabs[0]]: true });
    }
  }, []);

  const groupedRegistrationTabs = {
    "Apply for Certification": ["Expression of Interest", "Contribution"],
    "Pillar 3 - Programme Intervention & Resilience": [
      "Activities & Programme Management",
      "Risk, Resilience & Reputation",
    ],
    "Pillar 4 - Infrastructure, Finance & Compliance": [
      "Operations",
      "Finance",
      "Compliance",
      "Data Privacy & Security",
    ],
    "Pillar 5 - Governance & Accountability": ["Governance", "Accountability"],
    "Capacity Building for Greater Transparency": [
      "Workshops Attended",
      "Participation in Research",
    ],
  };
  useEffect(() => {
    if (localStorage.getItem("goToEOI") === "1") {
        // Set the Expression of Interest tab as active
        setSubTabs({ "Expression of Interest": true });
        localStorage.removeItem("goToEOI");
    }
  }, []);

  // useEffect(() => {
  //     if (!DbName) {
  //         localStorage.removeItem("RegKey")
  //     }
  // }, [])

  // bronze hide checking api

  // const gsnNoFromStorage = localStorage.getItem('gsn_no');

  // useEffect(() => {
  //     if (!gsnNoFromStorage) {
  //         // setHideTabs({ "Statutory Information & Documentation": true })
  //     }
  // }, [gsnNoFromStorage])
  const dataBase = DbName;
  const {
    isLoading: gsnLoading,
    data: gsnNumber,
    error,
  } = useQuery({
    queryKey: ["gsnNumber", application_no],
    queryFn: () =>
      BronzeSectionGsnGet(
        application_no,
        application_no && dataBase ? dataBase : "Pending DB"
      ),
    enabled: !!application_no,
    refetchOnWindowFocus: false,
    retry: 2, // Limit retries if the request is failing
  });
  useEffect(() => {
    if (gsnNumber?.data?.gsn_no) {
      localStorage.setItem("gsn_no", gsnNumber.data.gsn_no);
    }
  }, [gsnNumber?.data?.gsn_no]);
  useEffect(() => {
    if (location.state === 'fromLogin') {
      setTabs({ 'Organisation Summary': true })
      setSubTabs({ 'PAN and Legal Registration': true })
      navigate('/registration', { replace: true })
    }
  }, []);

  const LogoutSec = () => {
    // Clear local storage
    localStorage.clear();

    // Clear all cookies
    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
    });

    // Redirect with a full page reload
    window.location.replace("/loginDataUser");
  };

  if (gsnLoading) return <Loading />;

  return (
    <>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        <Drawer className="z-[12] " variant="permanent" open={open}>
          <DrawerHeader
            sx={{
              justifyContent: "flex-start",
              minHeight: "100%",
              height: "100px",
            }}
            className="flex flex-col bg-white gap-2 justify-start items-start"
          >
            {open && (
              <>
                <div className="w-[100%]  pl-[10px] cursor-pointer flex justify-start">
                  <Link to={'/'}>
                  <ImageComp 
                    source="/Images/logo.png"
                    className="h-[37px] mt-[10px]"
                  />
                  </Link>
                </div>
                <div className="flex pl-[10px] w-[100%] items-center justify-between">
                  <HeaderCompo
                    className="text-[15px] font-[500] mt-0 mb-0"
                    tagType="h3"
                    text={"New NPO Registration"}
                  />
                  <div className=" h-fit rounded-full bg-[#004878]">
                    <IconButton onClick={handleDrawerClose}>
                      {theme.direction === "rtl" ? (
                        <ChevronRightIcon className="text-white text-3xl" />
                      ) : (
                        <ChevronLeftIcon className="text-white text-3xl" />
                      )}
                    </IconButton>
                  </div>
                </div>
              </>
            )}
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 0,
                ...(open && { display: "none" }),
                justifyContent: "flex-start",
                marginTop: "10px",
              }}
            >
              <MenuIcon />
            </IconButton>
          </DrawerHeader>

          <List
            sx={{
              overflowY: "scroll",
              scrollbarWidth: "none", // Firefox
              height: "87vh",
              "&::-webkit-scrollbar": {
                display: "none", // Safari and Chrome
              },
            }}
          >
            <Divider />
            {open &&
              registrationTabs?.map((text, index) => {
                if (!gsnNumber?.data?.gsn_no) {
                  if (aFterRegistrationTab.includes(text.tab)) {
                    return null; // Skip rendering this tab
                  }
                }
                if (!token) {
                  if (isTokenTabs.includes(text.tab)) {
                    return null; // Skip rendering this tab
                  }
                }
                // Check if this tab is the start of a parent tab group
                const parentTab = Object.keys(groupedRegistrationTabs).find(
                  (parent) =>
                    groupedRegistrationTabs[parent]?.includes(text.tab)
                );

                if (
                  parentTab &&
                  text.tab === groupedRegistrationTabs[parentTab][0]
                ) {
                  // Render parent tab only once
                  return (
                    <div key={parentTab}>
                      {/* Parent Tab */}
                      <div
                        onClick={() =>
                          setIsParentTabOpen((prev) => ({
                            ...prev,
                            [parentTab]: !prev[parentTab],
                          }))
                        }
                        className="w-[100%] flex justify-between items-center"
                      >
                        <ListItem disablePadding sx={{ display: "block" }}>
                          <ListItemButton
                            sx={{
                              minHeight: 48,
                              justifyContent: open ? "initial" : "center",
                              pl: 2.5,
                              pr: 0,
                            }}
                          >
                            <ListItemText
                              primary={parentTab}
                              sx={{ opacity: open ? 1 : 0, fontSize: "30px" }}
                            />
                            {isParentTabOpen?.[parentTab] ? (
                              <ArrowDropUpIcon />
                            ) : (
                              <ArrowDropDownIcon />
                            )}
                          </ListItemButton>
                        </ListItem>
                      </div>

                      {/* Render child tabs when parent tab is open */}
                      {isParentTabOpen?.[parentTab] &&
                        groupedRegistrationTabs[parentTab]?.map((childTab) => {
                          const childTabData = registrationTabs.find(
                            (tab) => tab.tab === childTab
                          );

                          return (
                            <div key={childTab}>
                              {/* Render Child Tab */}
                              <div
                                onClick={() => openSubTabs(childTab)}
                                className="w-[100%] flex justify-between items-center"
                              >
                                <ListItem
                                  disablePadding
                                  sx={{ display: "block" }}
                                >
                                  <ListItemButton
                                    sx={{
                                      minHeight: 48,
                                      justifyContent: open
                                        ? "initial"
                                        : "center",
                                      pl: 5,
                                      pr: 2.5,
                                    }}
                                  >
                                    <ListItemText
                                      primary={childTab}
                                      sx={{
                                        opacity: open ? 1 : 0,
                                        fontSize: "30px",
                                      }}
                                    />
                                    {tabs?.[childTab] ? (
                                      <ArrowDropUpIcon />
                                    ) : (
                                      <ArrowDropDownIcon />
                                    )}
                                  </ListItemButton>
                                </ListItem>
                              </div>

                              {/* Render Subtabs under Child Tab */}
                              {tabs?.[childTab] &&
                                childTabData?.subTabs.map((subTab) => (
                                  <div
                                    key={subTab}
                                    className="p-[10px] pl-[20px] w-[100%]"
                                  >
                                    <ListItem
                                      disablePadding
                                      onClick={() => updateSubtab(subTab)}
                                      sx={{
                                        display: "block",
                                        backgroundColor:
                                          subTabs?.[subTab] &&
                                          open &&
                                          "#004878",
                                        borderRadius: "40px",
                                      }}
                                    >
                                      <ListItemButton>
                                        <ListItemIcon>
                                          <CircleIcon
                                            fontSize="small"
                                            sx={{
                                              fontSize: "15px",
                                              color:
                                                subTabs?.[subTab] &&
                                                open &&
                                                "white",
                                            }}
                                          />
                                        </ListItemIcon>
                                        <ListItemText
                                          primary={subTab}
                                          sx={{
                                            opacity: open ? 1 : 0,
                                            color:
                                              subTabs?.[subTab] &&
                                              open &&
                                              "white",
                                          }}
                                        />
                                      </ListItemButton>
                                    </ListItem>
                                  </div>
                                ))}
                            </div>
                          );
                        })}
                    </div>
                  );
                }

                // Skip rendering individual child tabs under parent groups
                if (parentTab) return null;

                // Render all other tabs that are not part of any parent tab group
                return (
                  <div key={text.tab}>
                    <div
                      onClick={() => openSubTabs(text.tab)}
                      className="w-[100%] flex justify-between items-center"
                    >
                      <ListItem
                        onClick={() => selectTab(text.tab)}
                        disablePadding
                        sx={{ display: "block" }}
                      >
                        <ListItemButton
                          sx={{
                            minHeight: 48,
                            justifyContent: open ? "initial" : "center",
                            px: 2.5,
                          }}
                        >
                          <ListItemText
                            primary={text.tab}
                            sx={{ opacity: open ? 1 : 0, fontSize: "30px" }}
                          />
                        </ListItemButton>
                      </ListItem>
                      {tabs?.[text.tab] ? (
                        <ArrowDropUpIcon />
                      ) : (
                        <ArrowDropDownIcon />
                      )}
                    </div>

                    {open &&
                      text?.subTabs.map((ele) =>
                        tabs?.[text.tab] ? (
                          <div className="p-[10px] w-[100%]" key={ele}>
                            <ListItem
                              onClick={() => updateSubtab(ele)}
                              disablePadding
                              sx={{
                                display: "block",
                                backgroundColor:
                                  subTabs?.[ele] && open && "#004878",
                                borderRadius: "40px",
                              }}
                            >
                              <ListItemButton
                                sx={{
                                  minHeight: 48,
                                  justifyContent: open ? "initial" : "center",
                                  px: 2.5,
                                }}
                              >
                                <ListItemIcon
                                  sx={{
                                    marginLeft: "0",
                                    minWidth: "30px",
                                    opacity: open ? 1 : 0,
                                  }}
                                >
                                  <CircleIcon
                                    sx={{
                                      fontSize: "15px",
                                      color: subTabs?.[ele] && open && "white",
                                    }}
                                  />
                                </ListItemIcon>
                                <ListItemText
                                  primary={ele}
                                  sx={{
                                    opacity: open ? 1 : 0,
                                    color: subTabs?.[ele] && open && "white",
                                  }}
                                />
                              </ListItemButton>
                            </ListItem>
                          </div>
                        ) : null
                      )}
                  </div>
                );
              })}
          </List>

          <div className="flex justify-end w-[100%] p-[15px]">
            <div
              className="cursor-pointer"
              onClick={() => {
                LogoutSec();
              }}
            >
              <LogoutIcon
                id="RegLogoutIcon"
                className="text-[red] rotate-180 text-[50px]"
              />
            </div>
          </div>
          <Divider />
        </Drawer>
        <Box
          component="main"
          sx={{
            padding: "30px",
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          {
            // initial sections
            subTabs?.["Get Started"] ? (
              <Initial setSubTabs={setSubTabs} />
            ) : // discover sections
              subTabs?.["PAN and Legal Registration"] ? (
                <Pan setSubTabs={setSubTabs} />
              ) : subTabs?.["Addresses"] ? (
                <LegalRegistration setSubTabs={setSubTabs} />
              ) : subTabs?.[`Head of Organisation's Details`] ? (
                <HeadOfOrganization setSubTabs={setSubTabs} />
              ) : subTabs?.["Social Media Profile"] ? (
                <ContactPersonOfOrganization setSubTabs={setSubTabs} />
              ) : subTabs?.["Contact Details"] ? (
                <BriefDescriptionAboutNPO setSubTabs={setSubTabs} />
              ) : subTabs?.["What We Do"] ? (
                <SeeWhatWeDo setSubTabs={setSubTabs} />
              ) : subTabs?.["Promoted by"] ? (
                <Section7 setSubTabs={setSubTabs} />
              ) : subTabs?.["Undertaking"] ? (
                <Section8 setSubTabs={setSubTabs} />
              ) : subTabs?.["Profile Related Information"] ? (
                <Section9 setSubTabs={setSubTabs} />
              ) : // Registrations sections

                subTabs?.["Tax exemption and deduction"] ? (
                  <ExemptionAndDeduction setSubTabs={setSubTabs} />
                ) : subTabs?.["FCRA Details"] ? (
                  <FcraDetials setSubTabs={setSubTabs} />
                ) : subTabs?.["Other registration details"] ? (
                  <McaDetails setSubTabs={setSubTabs} />
                ) : subTabs?.["Annual financial details"] ? (
                  <AnnualFinancialDetails setSubTabs={setSubTabs} />
                ) : subTabs?.["Sustainable Development Goals (SDGs)"] ? (
                  <SustainableDevelopment setSubTabs={setSubTabs} />
                ) : subTabs?.["Other organisation details"] ? (
                  <OtherOrganisationDetails setSubTabs={setSubTabs} />
                ) : // Checking the GSN number and displaying an error message or appropriate components if necessary.

                  error?.response?.data ? (
                    <div className="flex justify-center">
                      <h6>{error?.response?.data?.status_message.split(".")[0]}</h6>
                    </div>
                  ) : subTabs?.["Donation Information"] ? (
                    <DonationInformation />
                  ) : subTabs?.["Organisation Details"] ? (
                    <OrganizationDetails setSubTabs={setSubTabs} />
                  ) : subTabs?.["Head and Finance Team Details"] ? (
                    <HeadAndFinanceTeam setSubTabs={setSubTabs} />
                  ) : subTabs?.["Certification Interest & Financial Readiness"] ? (
                    <CertificationInterestFinancialReadiness
                      setSubTabs={setSubTabs}
                    />
                  ) : subTabs?.["Additional Information and Undertakings"] ? (
                    <AdditionalInformation />
                  ) : subTabs?.["Expression of Interest"] ? (
                    <ExpressionOfInterest setSubTabs={setSubTabs} />
                  ) : subTabs?.["Donor Details"] ? (
                    <DonationInformation setSubTabs={setSubTabs} />
                  ) : subTabs?.["Undertaking & Contact Information"] ? (
                    <UndertakingInformation setSubTabs={setSubTabs} />
                  ) : subTabs?.["Donation Documents"] ? (
                    <DonationDocuments setSubTabs={setSubTabs} />
                  ) : subTabs?.["Additional Organisational Details"] ? (
                    <BasicInformation
                      gsnNumber={gsnNumber}
                      error={error}
                      gsnLoading={gsnLoading}
                      setSubTabs={setSubTabs}
                    />
                  ) : subTabs?.["Material Changes"] ? (
                    <MaterialChanges
                      gsnNumber={gsnNumber}
                      error={error}
                      gsnLoading={gsnLoading}
                      setSubTabs={setSubTabs}
                    />
                  ) : subTabs?.["Documents as explained"] ? (
                    <DocumentPart1
                      gsnNumber={gsnNumber}
                      error={error}
                      gsnLoading={gsnLoading}
                      setSubTabs={setSubTabs}
                    />
                  ) : subTabs?.["Details"] ? (
                    <Details />
                  ) : subTabs?.["History"] ? (
                    <History setSubTabs={setSubTabs} />
                  ) : subTabs?.["Target Segment"] ? (
                    <TargetSegment setSubTabs={setSubTabs} />
                  ) : subTabs?.["Vision"] ? (
                    <Vision setSubTabs={setSubTabs} />
                  ) : subTabs?.["Mission"] ? (
                    <Mission setSubTabs={setSubTabs} />
                  ) : subTabs?.["Good Governance Practices"] ? (
                    <GoodGovernancePractices setSubTabs={setSubTabs} />
                  ) : subTabs?.["Strategy & Goals"] ? (
                    <StrategyAndGoal setSubTabs={setSubTabs} />
                  ) : subTabs?.["Undertaking2"] ? (
                    <Undertaking2 setSubTabs={setSubTabs} />
                  ) : subTabs?.["Top Programmes"] ? (
                    <TopProgramme setSubTabs={setSubTabs} />
                  ) : subTabs?.["Risk And Reputation"] ? (
                    <RiskAndReputation setSubTabs={setSubTabs} />
                  ) : subTabs?.["Prevention Of Risk"] ? (
                    <PreventionOfRisk setSubTabs={setSubTabs} />
                  ) : subTabs?.["Organisational Resilence"] ? (
                    <OrganisationalResilence setSubTabs={setSubTabs} />
                  ) : subTabs?.["External References"] ? (
                    <ExternalReferences setSubTabs={setSubTabs} />
                  ) : subTabs?.["People Engaged"] ? (
                    <PeopleEngaged setSubTabs={setSubTabs} />
                  ) : subTabs?.["Operations Planning & Management"] ? (
                    <OperationsPlanning setSubTabs={setSubTabs} />
                  ) : subTabs?.["Collaborations"] ? (
                    <Collaborations setSubTabs={setSubTabs} />
                  ) : subTabs?.["Donation Information"] ? (
                    <DonationInformation />
                  ) : subTabs?.["Undertaking "] ? (
                    <Undertaking2 setSubTabs={setSubTabs} />
                  ) : subTabs?.["Staff Distribution"] ? (
                    <StaffDistribution setSubTabs={setSubTabs} />
                  ) : subTabs?.["Monthly Compensation"] ? (
                    <MonthlyCompensation setSubTabs={setSubTabs} />
                  ) : subTabs?.["People Engaged Based on Nature of Engagement"] ? (
                    <PeopleEngagedBasedOnNature setSubTabs={setSubTabs} />
                  ) : subTabs?.["People Engaged Based On Diversity"] ? (
                    <PeopleEngagedBasedOnDiversity setSubTabs={setSubTabs} />
                  ) : subTabs?.["Sources of Funding"] ? (
                    <SourcesOfFunding setSubTabs={setSubTabs} />
                  ) : subTabs?.["Programme Details"] ? (
                    <ProgrammeDetails setSubTabs={setSubTabs} />
                  ) : subTabs?.["Top Donors"] ? (
                    <TopDonors setSubTabs={setSubTabs} />
                  ) : subTabs?.["Balance Sheet"] ? (
                    <BalanceSheet setSubTabs={setSubTabs} />
                  ) : subTabs?.["Receipts & Payments"] ? (
                    <RecieptsAndPayments setSubTabs={setSubTabs} />
                  ) : subTabs?.["Income & Expenditure"] ? (
                    <IncomeAndExpenditure setSubTabs={setSubTabs} />
                  ) : subTabs?.["Audit & Auditor Details"] ? (
                    <AuditAndAuditorDetails setSubTabs={setSubTabs} />
                  ) : subTabs?.["Bank Account Details"] ? (
                    <BankAccountDetails setSubTabs={setSubTabs} />
                  ) : subTabs?.["Accounting Practices"] ? (
                    <AccountingPractices setSubTabs={setSubTabs} />
                  ) : subTabs?.["Financial Reporting to Funders"] ? (
                    <FinancialReporting setSubTabs={setSubTabs} />
                  ) : subTabs?.["Receipts & Income"] ? (
                    <ReceiptsAndIncome setSubTabs={setSubTabs} />
                  ) : subTabs?.["Payments & Expenditure"] ? (
                    <PaymentsAndExpenditure setSubTabs={setSubTabs} />
                  ) : subTabs?.["Assets"] ? (
                    <Assets setSubTabs={setSubTabs} />
                  ) : subTabs?.["Liabilities"] ? (
                    <Liabilities setSubTabs={setSubTabs} />
                  ) : subTabs?.["Data Privacy & Security"] ? (
                    <DataPrivacyAndSecurity setSubTabs={setSubTabs} />
                  ) : subTabs?.["Capabilities"] ? (
                    <Capabilities setSubTabs={setSubTabs} />
                  ) : subTabs?.["Challenges"] ? (
                    <Challenges setSubTabs={setSubTabs} />
                  ) : subTabs?.["Accountability"] ? (
                    <Accountability setSubTabs={setSubTabs} />
                  ) : subTabs?.["Internal Compliance"] ? (
                    <InternalCompliance setSubTabs={setSubTabs} />
                  ) : subTabs?.["Compliance with Primary Regulatory Authority"] ? (
                    <CompliancePrimary setSubTabs={setSubTabs} />
                  ) : subTabs?.["Compliance with Income Tax"] ? (
                    <ComplianceIncome setSubTabs={setSubTabs} />
                  ) : subTabs?.["Compliance with FCRA"] ? (
                    <ComplianceFcra setSubTabs={setSubTabs} />
                  ) : subTabs?.["Compliance with Stakeholders"] ? (
                    <ComplianceStakeholders setSubTabs={setSubTabs} />
                  ) : subTabs?.["Governing Body Member Details"] ? (
                    <GoverningBodyMemberDetails setSubTabs={setSubTabs} />
                  ) : subTabs?.["Functioning Of The Board"] ? (
                    <FunctioningOfTheBoard setSubTabs={setSubTabs} />
                  ) : subTabs?.["Good Governance Practices"] ? (
                    <GoodGovernancePractices setSubTabs={setSubTabs} />
                  ) : subTabs?.["Social Impact"] ? (
                    <SocialImpact setSubTabs={setSubTabs} />
                  ) : subTabs?.["Needs & Asks"] ? (
                    <NeedsOrAsk setSubTabs={setSubTabs} />
                  ) : subTabs?.["Workshop Details"] ? (
                    <WorkshopAttended setSubTabs={setSubTabs} />
                  ) : (
                    ""
                  )
          }
        </Box>
      </Box>
    </>
  );
};

export default RegistrationMainPage;
